import { Component } from '@angular/core';
import { TooltipButtonComponent } from '../../../components/button/tooltip-button.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { OverlayComponent } from '../../../components/overlay/overlay.component';

@Component({
  selector: 'td-wb-w8ben-tooltip',
  templateUrl: 'w8ben-form-tooltip.component.html',
  styleUrls: ['w8ben-form-tooltip.component.scss'],
  imports: [
    TooltipButtonComponent,
    OverlayComponent,
    TranslatePipe
  ]
})

export class W8BenFormTooltipComponent {}

